import React from 'react'
import { confirmAlert as _confirmAlert } from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'
import { PaneCloseButton } from './Buttons'
import { t } from 'ttag'

interface IConfirmAlert {
    title?: string,
    message: string,
    confirmLabel: string | React.ReactNode,
    cancelLabel?: string,
    onConfirm: () => void,
    onCancel?: () => void,
    overlayClassName?: string,
}

export function confirmAlert(options: IConfirmAlert) {
    let { title, message, confirmLabel, cancelLabel, onConfirm, onCancel, overlayClassName } = options

    _confirmAlert({
        customUI: ({ onClose }: { onClose: () => void }) => (
            <div className={`${'react-confirm-alert-overlay ' + (overlayClassName || '')}`}>
                <div className="react-confirm-alert">
                    <div className="react-confirm-alert-body" style={{ position: 'relative' }}>
                        {/* Close button absolutely positioned in top right */}
                        <PaneCloseButton
                            enabled={true}
                            onClick={() => {
                                if (onCancel) onCancel()
                                onClose()
                            }}
                            tooltip={/* translator: important */ t`Close`}
                            className='note-dialog-close-button absolute-top-8-right-8'
                        />
                        {title && <h1 className="react-confirm-alert-title">{title}</h1>}
                        <div className="react-confirm-alert-message" style={{ margin: '1em 0' }}>
                            {message}
                        </div>
                        <div className="react-confirm-alert-button-group">
                            {cancelLabel && (
                                <button
                                    className="react-confirm-alert-button react-confirm-alert-button-cancel"
                                    onClick={() => {
                                        if (onCancel) onCancel()
                                        onClose()
                                    }}
                                >
                                    {cancelLabel}
                                </button>
                            )}
                            <button
                                className="react-confirm-alert-button react-confirm-alert-button-confirm"
                                onClick={() => {
                                    onConfirm()
                                    onClose()
                                }}
                            >
                                {confirmLabel}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    })
}
